type SectionHeadingProps = {
  title: string;
  count?: number;
  action?: React.ReactNode;
};

const SectionHeading = ({ title, count, action }: SectionHeadingProps) => (
  <div className="flex items-end justify-between gap-6 border-b border-slate-200 pb-4">
    <h2 className="m-0 text-2xl! font-bold">
      {title}
      {count !== undefined && (
        <span className="ml-2 font-normal text-muted-foreground">
          ({count})
        </span>
      )}
    </h2>
    {action}
  </div>
);

export default SectionHeading;
